import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  n: '01',
  title: 'Entendemos',
  desc: 'Mapeamos cómo funciona hoy tu proceso.'
}, {
  n: '02',
  title: 'Diseñamos',
  desc: 'Definimos la arquitectura y los flujos que deben conectarse.'
}, {
  n: '03',
  title: 'Construimos',
  desc: 'Implementamos presencia digital, automatizaciones, CRM e IA.'
}, {
  n: '04',
  title: 'Evolucionamos',
  desc: 'Medimos y ajustamos el sistema según tu empresa.'
}];
export function HowWeBuild() {
  return <section className="bg-arena py-[36px] md:py-[52px]" data-id="element-159" data-mp="2jirjm0cw1td4">
      <div className="max-w-[1100px] mx-auto px-6 md:px-20" data-id="element-160" data-mp="2y8p3w57p5yx1">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="mb-8 md:mb-10 text-center max-w-[560px] mx-auto" data-id="element-161" data-mp="2tani3civzlhv">
          <span className="block font-body text-[11px] uppercase font-medium text-salvia tracking-[0.15em] mb-4" data-id="element-162" data-mp="3grezl0q0xpo9">
            METODOLOGÍA
          </span>
          <h2 className="font-display text-[28px] md:text-[38px] font-bold text-carbon leading-[1.15]" data-id="element-163" data-mp="3kts6vtkf5vn5">
            Cómo construimos tu sistema.
          </h2>
        </motion.div>

        <div className="relative grid grid-cols-1 md:grid-cols-4 gap-6 md:gap-5" data-id="element-164" data-mp="3us7v9os2aqsy">
          {/* connecting line, desktop only */}
          <div aria-hidden="true" className="hidden md:block absolute top-[13px] left-[6%] right-[6%] h-px bg-carbon/10" data-id="element-165" data-mp="3kmzndfeqzzq" />

          {steps.map((step, idx) => <motion.div key={step.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.35,
          ease: 'easeOut',
          delay: idx * 0.08
        }} className="relative" data-id="element-166" data-mp="cdyy60wbxogn" data-mpi={idx}>
              <div className="flex items-center gap-3 mb-3" data-id="element-167" data-mp="1mtxw7f74akg">
                <span className="relative z-10 flex items-center justify-center w-7 h-7 rounded-full bg-verde text-arena font-display text-[11px] font-bold flex-shrink-0" data-id="element-168" data-mp="3stemlkhs36eb">
                  {idx + 1}
                </span>
                <span className="font-body text-[11px] text-carbon/30 tracking-[0.1em]" data-id="element-169" data-mp="6kn6t87vviof">
                  {step.n}
                </span>
              </div>
              <h3 className="font-display text-[17px] font-bold text-carbon mb-1.5" data-id="element-170" data-mp="fdz3rr95pz38">
                {step.title}
              </h3>
              <p className="font-body text-[13.5px] text-carbon/60 leading-[1.6]" data-id="element-171" data-mp="u9yaoykj5t6s">
                {step.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}